import { render, staticRenderFns } from "./Wordcloud.vue?vue&type=template&id=29833a73&scoped=true&"
import script from "./Wordcloud.vue?vue&type=script&lang=ts&"
export * from "./Wordcloud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29833a73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29833a73')) {
      api.createRecord('29833a73', component.options)
    } else {
      api.reload('29833a73', component.options)
    }
    module.hot.accept("./Wordcloud.vue?vue&type=template&id=29833a73&scoped=true&", function () {
      api.rerender('29833a73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-view/components/Wordcloud.vue"
export default component.exports